module.exports = __webpack_public_path__ + "static/media/director.65b8f827.jpg";